export function initBookConfirmation() {
  const confirmation = document.getElementById('book-confirmation');
  const bookingForm = document.getElementById('book-form');
  
  if (!confirmation || !bookingForm) return;

  // Listen for CF7 successful submission
  document.addEventListener('wpcf7mailsent', function(event) {
    bookingForm.closest('section').classList.add('hidden');
    confirmation.classList.remove('hidden');
  }, false);
}